// extracted by mini-css-extract-plugin
export default {"root":"aVng1S"};